import { AuthService } from "./services/auth.service";
var AppComponent = /** @class */ (function () {
    function AppComponent(auth) {
        this.auth = auth;
    }
    return AppComponent;
}());
export { AppComponent };
